import { render, staticRenderFns } from "./QQ.vue?vue&type=template&id=0328fa84&scoped=true&"
import script from "./QQ.vue?vue&type=script&lang=js&"
export * from "./QQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328fa84",
  null
  
)

export default component.exports